'use client'

import { Button } from '@mentora/ui-components'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { acceptConsent, rejectConsent } from './consent'
import { useConsentStatus } from './use-consent-status'

/** Asks once per storefront domain; reopened from the footer's cookie-preferences link. */
export function ConsentBanner({ privacyHref }: { privacyHref: string }) {
  const t = useTranslations('consent')
  const status = useConsentStatus()

  if (status !== 'pending')
    return null

  return (
    <section
      aria-label={t('title')}
      data-testid="consent-banner"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-card p-4 text-card-foreground shadow-lg sm:inset-x-auto sm:bottom-4 sm:left-4 sm:max-w-md sm:rounded-lg sm:border"
    >
      <h2 className="text-sm font-semibold text-foreground">{t('title')}</h2>
      <p className="mt-1 text-sm text-muted-foreground">
        {t('body')}
        {' '}
        <Link href={privacyHref} className="text-foreground underline underline-offset-2">
          {t('privacyLink')}
        </Link>
      </p>
      <div className="mt-3 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <Button type="button" variant="outline" className="min-h-11 sm:min-h-9" onClick={rejectConsent}>
          {t('reject')}
        </Button>
        <Button type="button" className="min-h-11 sm:min-h-9" onClick={acceptConsent}>
          {t('accept')}
        </Button>
      </div>
    </section>
  )
}
